import React from 'react';
import './Bottlehandlestabl.css';



const Bottlehandlestabl = () => {
    return (
        <div className="mold-container">
            <h2 className="heading">5 gallon Water Bottle Handles Production Line</h2>
            <p><strong>Case for reference:</strong></p>
            <div className="details-grid">
                <div className="left-column">
                    <p><strong>
                        Machine Model</strong> </p>
                    <p><strong>Mold Cavity</strong> </p>
                    <p><strong>Cycle Time	</strong> </p>
                    <p><strong>Weight</strong></p>
                    <p><strong>Material</strong></p>

                </div>
                <div className="right-column">
                    <p>Disha KII288-S7</p>
                    <p>	12 Cavities</p>
                    <p>11s</p>
                    <p> 1.3g</p>
                    <p>HDPE</p>
                </div>
            </div>
        </div>
    );
};

export default Bottlehandlestabl;
